import { Action } from '../core';

export * from './auth';
export * from './authors';
export * from './calendar';
export * from './calendarFeel';
export * from './crossStorage';
export * from './customer';
export * from './gymAccess';
export * from './loading';
export * from './packages';
export * from './payments';
export * from './product';
export * from './provider';
export * from './providersFeel';
export * from './registerBiz';
export * from './staff';
export * from './users.js';
export * from './webIntegrations';
export * from './widgetTypes';
export * from './window';

export const HOLIDAYS_GET_MANY = { entity: 'HOLIDAY', action: Action.GET_MANY };
